export default __webpack_public_path__ + "clever-logo.png";